import { render, staticRenderFns } from "./APP.vue?vue&type=template&id=528d8058&scoped=true&"
import script from "./APP.vue?vue&type=script&lang=js&"
export * from "./APP.vue?vue&type=script&lang=js&"
import style0 from "./APP.vue?vue&type=style&index=0&id=528d8058&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d8058",
  null
  
)

export default component.exports